export default {
    getArpRecords:          { method: 'get', url: 'arp/records' },
    getArpRecord:           { method: 'get', url: 'arp/records/{id}' },
    getArpRecordTypes:      { method: 'get', url: 'arp/records/types' },
    getArpResponsibleTypes: { method: 'get', url: 'arp/records/responsible-types' },
    getArpEstablishments:   { method: 'get', url: 'arp/records/establishments' },
    getArpStats:            { method: 'get', url: 'arp/records/stats' },
    verifyArpRecord:        { method: 'get', url: 'arp/records/verify/{establishmentKey}/{nsr}' },
    verifyArpChain:         { method: 'get', url: 'arp/records/verify-chain/{establishmentKey}' },
}
